import { render, staticRenderFns } from "./UnitInformation.vue?vue&type=template&id=47168323&scoped=true&"
import script from "./UnitInformation.vue?vue&type=script&lang=js&"
export * from "./UnitInformation.vue?vue&type=script&lang=js&"
import style0 from "./UnitInformation.vue?vue&type=style&index=0&id=47168323&lang=scss&scoped=true&"
import style1 from "./UnitInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47168323",
  null
  
)

export default component.exports